<template>
  <div>
    <div class="tabs is-small">
      <ul>
        <router-link :to="{ name: 'branch-games-general' }" active-class="is-active" tag="li" exact><a>General</a></router-link>
        <router-link :to="{ name: 'branch-games-list', params: { provider: 'redpipe' } }" active-class="is-active" tag="li" :class="{'is-active':provider=='redpipe'}"><a>RedPipe</a></router-link>
        <router-link :to="{ name: 'branch-games-list', params: { provider: 'flg' } }" active-class="is-active" tag="li"><a>FLG</a></router-link>
        <router-link :to="{ name: 'branch-games-list', params: { provider: 'hdraces' } }" active-class="is-active" tag="li"><a>HdRaces</a></router-link>
        <router-link :to="{ name: 'branch-games-list', params: { provider: 'bk' } }" active-class="is-active" tag="li"><a>Bk</a></router-link>
      </ul>
    </div>

    <router-view />
  </div>
</template>
<script>
  import breadcrumbsService from '../../../../../../services/breadcrumbs.service'

  export default {
    name: 'branch-games',
    computed: {
      provider() {
        return this.$route.params.provider;
      }
    },
    mounted() {
      breadcrumbsService.dynamic.set({ key: "game-provider", func: () => this.provider });
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/branches/branch/games/index.vue